export default "__VITE_ASSET__CbXMjiso__"